/* hooks/queryState.js — переходы состояния useFakeQuery (stale-while-revalidate, kitchen-ux A2, K-33).
   Чистые функции: хук (hooks/index.jsx) только применяет их.

   loading    — запрос в полёте (контракт прежний: потребители, которым важна свежесть —
                например, отправка в POS не шлёт устаревший план, — смотрят на него);
   refreshing — перезапрос ТОГО ЖЕ запроса, данные уже есть и остаются на экране:
                QueryBoundary и редакторы по нему не показывают скелетон;
   ошибка     — честная (данных нет), как и было.
   primeQuery — данные для СЛЕДУЮЩЕГО монтирования запроса с этим ключом (одноразово):
                редактор создал сущность и заменил верх стека на её id — новый экземпляр
                берёт ответ сервера сразу, без повторного запроса и скелетона. */

export const INITIAL_QUERY_STATE = { data: null, loading: true, refreshing: false, error: null };

export function startFetch(state, { sameIdentity }) {
  const keep = !!sameIdentity && state.data != null;
  return { ...state, loading: true, refreshing: keep, error: null };
}

export function fetchOk(state, data) {
  return { data, loading: false, refreshing: false, error: null };
}

export function fetchFail(state, error) {
  return { data: null, loading: false, refreshing: false, error };
}

export function sameDeps(a, b) {
  if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false;
  return a.every((x, i) => Object.is(x, b[i]));
}

const PRIMED = new Map();
export function primeQuery(key, data) {
  if (key != null && data !== undefined) PRIMED.set(key, data);
}
export function takePrimed(key) {
  if (!PRIMED.has(key)) return undefined;
  const d = PRIMED.get(key);
  PRIMED.delete(key);
  return d;
}
